import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=54fbdf7a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=54fbdf7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fbdf7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54fbdf7a')) {
      api.createRecord('54fbdf7a', component.options)
    } else {
      api.reload('54fbdf7a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=54fbdf7a&scoped=true&", function () {
      api.rerender('54fbdf7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2F7aqFCH97vr7/JS/comp/SearchFilterTokens.vue"
export default component.exports